export function buildPermissionTree(permissions = []) {
  const root = { children: {}, permissions: [] };

  permissions.forEach(permission => {
    const pathSegments = String(permission.uiPath || permission.ui_path || "")
      .split("/")
      .filter(Boolean);
    const labelSegments = String(
      permission.uiPathLabels || permission.ui_path_labels || ""
    )
      .split("/")
      .filter(Boolean);

    let current = root;
    pathSegments.forEach((segment, index) => {
      if (!current.children[segment]) {
        current.children[segment] = {
          id: segment,
          label: labelSegments[index] || segment,
          children: {},
          permissions: []
        };
      }
      current = current.children[segment];
    });

    current.permissions.push(permission);
  });

  const toArray = node =>
    Object.values(node.children)
      .map(child => ({
        id: child.id,
        label: child.label,
        permissions: child.permissions.slice().sort((a, b) => {
          const orderA = a.uiOrder != null ? a.uiOrder : a.ui_order || 0;
          const orderB = b.uiOrder != null ? b.uiOrder : b.ui_order || 0;
          return orderA - orderB;
        }),
        children: toArray(child)
      }))
      .sort((a, b) => a.label.localeCompare(b.label, "pt-BR"));

  return toArray(root);
}

function permissionMatchesQuery(permission, query) {
  const text = [
    permission.description,
    permission.action,
    permission.subject,
    permission.module
  ]
    .filter(Boolean)
    .join(" ")
    .toLowerCase();
  return text.includes(query);
}

export function filterPermissionTree(nodes = [], searchText = "") {
  const query = String(searchText).trim().toLowerCase();
  if (!query) return nodes;

  const filterNode = node => {
    const labelMatch = String(node.label || "")
      .toLowerCase()
      .includes(query);

    if (labelMatch) {
      return node;
    }

    const permissions = (node.permissions || []).filter(permission =>
      permissionMatchesQuery(permission, query)
    );
    const children = (node.children || []).map(filterNode).filter(Boolean);

    if (!permissions.length && !children.length) {
      return null;
    }

    return {
      ...node,
      permissions,
      children
    };
  };

  return nodes.map(filterNode).filter(Boolean);
}

export function getCounterpartCode(role) {
  if (!role) return "";
  if (typeof role.counterpart === "string") return role.counterpart;
  return (
    (role.counterpart &&
      (role.counterpart.externalRoleCounterpartId ||
        role.counterpart.external_role_counterpart_id)) ||
    ""
  );
}
